import { VStack } from "native-base";
import React from "react";

import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";

import Form from "./components/Form";
import { LoginScreenProps } from "./types";

const LoginMobile = ({
  isSubmiting,
  onSubmit,
  onBack,
  onRecoveryPass,
  onSingUp,
}: LoginScreenProps) => {
  return (
    <Container Header={<MobileHeader title="Entre ou Cadastre-se" onBackPress={() => onBack()} />}>
      <VStack pt="1/3" h="full" justifyContent="space-evenly">
        <Form
          isSubmiting={isSubmiting}
          onSubmit={onSubmit}
          onRecoveryPass={onRecoveryPass}
          onSingUp={onSingUp}
        />
      </VStack>
    </Container>
  );
};

export default LoginMobile;
